<template>
  <div>
    <div id="box" style="display: none;">
    </div>
    <!-- <div class="box"></div> -->
    <!-- 定部 -->
    <div class="header">
      <div class="header-l" @click="navto(1)">
        <img src="../../../assets/images/手机端/首页手机端/logo拷贝.png" alt="">
      </div>
      <div id="btn" class="header-r" @click="addnav">
        <img src="../../../assets/images/手机端/首页手机端/更多.png" alt="">
      </div>
    </div>
    <div class="top-img">
      <img src="../../../assets/images/手机端/123(3)/首页背景图.png" alt="">
      <h3>精致与实用本不矛盾</h3>
    </div>
    <div class="main-1">
      <div class="top_tag">
        <img src="../../../assets/images/手机端/首页 手机端/组26.png" alt="" />
        <div class="toptext_box">
          <p class="date">100 <span>+</span></p>
          <h3 class="text">拥有数十项软件著作权</h3>
        </div>
      </div>
      <div class="top_tag">
        <img src="../../../assets/images/手机端/首页 手机端/组27.png" alt="">
        <div class="toptext_box">
          <p class="date">500 <span>+</span></p>
          <h3 class="text">成功服务于众多客户</h3>
        </div>
      </div>
      <div class="top_tag">
        <img src="../../../assets/images/手机端/首页 手机端/组28.png" alt="" />
        <div class="toptext_box">
          <p class="date">25 <span style="left: 1rem;">+</span></p>
          <h3 class="text">丰富的系统开发和项目管理经验</h3>
        </div>
      </div>
      <!-- <ul>
            <li>
                <div class="main-img">
                    <img src="../../../assets/images/手机端/首页 手机端/组26.png" alt="">
                </div>
                <div >
                    <p class="date">100 <span>+</span></p>
                    <h3 class="text">拥有上百项发明专利和版权著作权</h3>
                </div>
            </li>
            <li>
                <div class="main-img">
                    <img src="../../../assets/images/手机端/首页 手机端/组27.png" alt="">
                </div>
                <div >
                    <p class="date">500 <span>+</span></p>
                    <h3 class="text">成功服务于上百家客户</h3>
                </div>
            </li>
            <li>
                <div class="main-img">
                    <img src="../../../assets/images/手机端/首页 手机端/组28.png" alt="">
                </div>
                <div >
                    <p class="date">25 <span>+</span></p>
                    <h3 class="text">多年信息化系统开发和管理经验</h3>
                </div>
            </li>
        </ul> -->
    </div>
    <div class="yubeishu">
      <h3>域贝电子证书系统</h3>
      <img src="../../../assets/images/手机端/首页手机端/组25.png" alt="">
      <div class="centre">
        <p>
          域贝电子证书系统可用于企事业单位、教育机构、社会组织等颁发证书的数字化管理。包括证书的批量发放、证书防伪溯源,证书查询打印等一系列数字化证书功能,对于提高办公效率、减少碳排放、增强组织公信力、方便客户等方面具有作用。
        </p>
        <!-- <a href="./productservice.html"> -->
        <button class="btn3" @click="goproductservice">查看更多</button>
        <!-- </a> -->
      </div>
    </div>
    <div class="yitihua">
      <h3>域贝一体化平台</h3>
      <p class="top-title">信息化数字化底座系统，解决应用孤岛问题,让应用互联互通，形成数据合力。</p>
      <ul>
        <li :class="{ listiscolor1: iscolor1 }" @click="clicklistcolor1">
          <div class="yitihua_limg">
            <img src="../../../assets/images/手机端/首页 手机端/账号一体化.png" alt="">
          </div>
          <div class="yitihua_rtext">
            <h3>账号一体化</h3>
            <p>统一身份认证，实现用户，组织，角色，权限统一化管理</p>
          </div>
        </li>
        <li :class="{ listiscolor2: iscolor2 }" @click="clicklistcolor2">
          <div class="yitihua_limg">
            <img src="../../../assets/images/手机端/首页 手机端/账号一体化.png" alt="">
          </div>
          <div class="yitihua_rtext">
            <h3>管理一体化</h3>
            <p>基于身份的管理体系，实现数据管理，数据访问，应用访问等灵活配置</p>
          </div>
        </li>
        <li :class="{ listiscolor3: iscolor3 }" @click="clicklistcolor3">
          <div class="yitihua_limg">
            <img src="../../../assets/images/手机端/首页 手机端/账号一体化.png" alt="">
          </div>
          <div class="yitihua_rtext">
            <h3>应用一体化</h3>
            <p>开放式应用接入模式，实现三方应用快速对接互联互动</p>
          </div>
        </li>
        <li :class="{ listiscolor4: iscolor4 }" @click="clicklistcolor4">
          <div class="yitihua_limg">
            <img src="../../../assets/images/手机端/首页 手机端/账号一体化.png" alt="">
          </div>
          <div class="yitihua_rtext">
            <h3>数据一体化</h3>
            <p>开放式标准数据接口，实现全域基础数据标准统一化</p>
          </div>
        </li>
        <li :class="{ listiscolor5: iscolor5 }" @click="clicklistcolor5">
          <div class="yitihua_limg">
            <img src="../../../assets/images/手机端/首页 手机端/账号一体化.png" alt="">
          </div>
          <div class="yitihua_rtext">
            <h3>服务一体化</h3>
            <p>开放式功能模块组件，实现信息，日志，文档，视频等通用服务</p>
          </div>
        </li>
      </ul>
      <button class="btn2" @click="gointegratedpage">查看更多</button>
    </div>
    <div class="main-2">
      <h3>域贝大数据平台</h3>
      <img src="../../../assets/images/手机端/首页 手机端/大数据图形.png" alt="">
      <p>以自主研发的第三代瑶池数据仓库为数据存储核心，实现了数据汇集、治理、资产、分析、服务、应用等数据全流程全生命周期大数据平台。</p>
    </div>
    <div class="main-3">
      <div class="main-3-botton img-1">
        <h3>安全高效的数据共享</h3>
        <p>Secure And Efhclent Deta Sharing</p>
        <h4>支持数据批量推拉，数据订阅等多种安全高效的数据共享方式</h4>
      </div>
      <div class="main-3-botton img-2">
        <h3>优异的数据搜索能力</h3>
        <p>Excellent Date Search Skills</p>
        <h4>基于全文搜索引擎Lucense，提供强大的实时流处理和数据检索动力</h4>
      </div>
      <div class="main-3-botton img-3">
        <h3>资产化的监控运维</h3>
        <p>Assets Monitoring Operation And Meintenenco</p>
        <h4>便携的数据质量全生命周期实时监控，以资产管理模式来运维数据</h4>
      </div>
      <div class="main-3-botton img-4">
        <h3>灵活的数据应用能力</h3>
        <p>Flaxlble Date Appllcation Capabllty</p>
        <h4>利用数据运算以及丰富的服务接口，赋能数据应用场景化需求</h4>
      </div>
      <div class="main-3-botton img-5">
        <h3>创新的可视化操作</h3>
        <p>Innovative Visual Operation</p>
        <h4>海量,异构，全域的数据汇聚可视化操控，支持数据流一键链接</h4>
      </div>
    </div>
    <div class="main-4">
      <button class="btn1" @click="godate">查看更多</button>
      <h3>解决方案</h3>
      <div class="nav" @click="addjiejue">

        <div class="swiper-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <img src="../../../assets/images/手机端/123(2)/教育.png" style="z-index: -1;" alt="">
              <div class="title_box">
                <h3>教育</h3>
                <div class="c"></div>
                <p>智慧教育一体化平台解决方案</p>
              </div>
              <div class="nav-bottom">
                <div class="bottom-textlist">
                  <div class="bottom-imglit">
                    <img src="../../../assets/images/手机端/222/图层619@2x.png" alt="">
                  </div>
                  温州市教育局
                </div>
                <div class="bottom-textlist">
                  <div class="bottom-imglit">
                    <img src="../../../assets/images/手机端/222/温州市教育考试院@2x.png" alt="">
                  </div>
                  温州市教育考试院
                </div>
                <div class="bottom-textlist">
                  <div class="bottom-imglit">
                    <img src="../../../assets/images/手机端/222/瓯海区教育局拷贝@2x.png" alt="">
                  </div>
                  温州市瓯海区教育局
                </div>
                <div class="bottom-textlist">
                  <div class="bottom-imglit">
                    <img src="../../../assets/images/手机端/222/苍南县教育局@2x.png" alt="">
                  </div>
                  苍南县教育局
                </div>
                <div class="bottom-textlist">
                  <div class="bottom-imglit">
                  </div>
                  乐清市教育局
                </div>
                <div class="bottom-textlist">
                  <div class="bottom-imglit">
                    <img src="../../../assets/images/手机端/222/瓯海区教育局拷贝@2x.png" alt="">
                  </div>
                  温州市瓯海区教育局
                </div>
              </div>
              <!-- <div class="swiper-button-next"></div> -->
            </div>
            <div class="swiper-slide">
              <img src="../../../assets/images/手机端/123(2)/公安.png" style="z-index: -1;" alt="">
              <div class="title_box">
                <h3>公安</h3>
                <div class="c"></div>
                <p>大数据平台解决方案</p>
              </div>
              <div class="nav-bottom">
                <div class="bottom-textlist">
                  <div class="bottom-imglit">
                  </div>
                  温州市公安局瓯海区分局
                </div>
                <div class="bottom-textlist">
                  <div class="bottom-imglit">
                  </div>
                  瑞安市公安局
                </div>
                <div class="bottom-textlist">
                  <div class="bottom-imglit">
                  </div>
                  温州市公安局鹿城区分局
                </div>
                <div class="bottom-textlist">
                  <div class="bottom-imglit">
                  </div>
                  平阳县公安局
                </div>
                <div class="bottom-textlist">
                  <div class="bottom-imglit">
                  </div>
                  苍南县公安局
                </div>
                <div class="bottom-textlist">
                  <div class="bottom-imglit">
                  </div>
                  无锡市公安局
                </div>
              </div>

              <!-- <div class="swiper-button-next"></div> -->
            </div>
            <div class="swiper-slide">
              <img src="../../../assets/images/手机端/123(2)/政企.png" style="z-index: -1;" alt="">
              <div class="title_box">
                <h3>政企</h3>
                <div class="c"></div>
                <p>智慧教育一体化平台解决方案</p>
              </div>
              <div class="nav-bottom">
                <div class="bottom-textlist">
                  <div class="bottom-imglit">
                    <img src="../../../assets/images/手机端/222/图层617@2x.png" alt="">
                  </div>
                  温州市城市建设发展集团有限公司
                </div>
                <div class="bottom-textlist">
                  <div class="bottom-imglit">
                    <img src="../../../assets/images/手机端/222/图层617@2x.png" alt="">
                  </div>
                  温州市数据管理发展集团有限公司
                </div>
                <div class="bottom-textlist">
                  <div class="bottom-imglit">
                    <img src="../../../assets/images/手机端/222/图层617@2x.png" alt="">
                  </div>
                  温州市教育投资集团有限公司
                </div>
                <div class="bottom-textlist">
                  <div class="bottom-imglit">
                    <img src="../../../assets/images/手机端/222/图层617@2x.png" alt="">
                  </div>
                  温州市市政工程建设开发有限公司
                </div>
                <div class="bottom-textlist">
                  <div class="bottom-imglit">
                    <img src="../../../assets/images/手机端/222/图层618@2x.png" alt="">
                  </div>
                  温州日报报业集团有限公司
                </div>
                <div class="bottom-textlist">
                  <div class="bottom-imglit">
                  </div>
                  前坤环境建设集团有限公司
                </div>
              </div>

              <!-- <div class="swiper-button-prev"></div> -->
            </div>
          </div>
          <!-- <div class="swiper-button-next"></div>
          <div class="swiper-button-prev"></div> -->
          <div class="swiper-pagination"></div>
        </div>

        <!-- <ul class="leftScrollul">
          <li class="leftScroll">
            <h3>教育</h3>
            <div class="c"></div>
            <p>智慧教育一体化平台解决方案</p>
            <div class="nav-bottom">
              <div class="bottom-textlist">
                  <div class="bottom-imglit">
                      <img src="../../../assets/images/手机端/222/图层619@2x.png" alt="">
                  </div>
                  温州市教育局
              </div>
              <div class="bottom-textlist">
                  <div class="bottom-imglit">
                      <img src="../../../assets/images/手机端/222/温州市教育考试院@2x.png" alt="">
                  </div>
                  温州市教育考试院
              </div>
              <div class="bottom-textlist">
                  <div class="bottom-imglit">
                      <img src="../../../assets/images/手机端/222/瓯海区教育局拷贝@2x.png" alt="">
                  </div>
                  温州市瓯海区教育局
              </div>
              <div class="bottom-textlist">
                  <div class="bottom-imglit">
                      <img src="../../../assets/images/手机端/222/苍南县教育局@2x.png" alt="">
                  </div>
                  苍南县教育局
              </div>
              <div class="bottom-textlist">
                  <div class="bottom-imglit">
                  </div>
                  乐清市教育局
              </div>
              <div class="bottom-textlist">
                  <div class="bottom-imglit">
                      <img src="../../../assets/images/手机端/222/瓯海区教育局拷贝@2x.png" alt="">
                  </div>
                  温州市瓯海区教育局
              </div>
            </div>
          </li>
          <li class="leftScroll">
              <h3>公安</h3>
              <div class="c"></div>
              <p>警务大数据解决方案</p>
              <div class="nav-bottom">
                  <div class="bottom-textlist">
                      <div class="bottom-imglit">
                          <img src="../../../assets/images/手机端/222/警徽拷贝2@2x.png" alt="">
                      </div>
                      温州市公安局瓯海区分局
                  </div>
                  <div class="bottom-textlist">
                      <div class="bottom-imglit">
                          <img src="../../../assets/images/手机端/222/警徽拷贝2@2x.png" alt="">
                      </div>
                      瑞安市公安局
                  </div>
                  <div class="bottom-textlist">
                      <div class="bottom-imglit">
                          <img src="../../../assets/images/手机端/222/警徽拷贝2@2x.png" alt="">
                      </div>
                      温州市公安局鹿城区分局
                  </div>
                  <div class="bottom-textlist">
                      <div class="bottom-imglit">
                          <img src="../../../assets/images/手机端/222/警徽拷贝2@2x.png" alt="">
                      </div>
                      平阳县公安局
                  </div>
                  <div class="bottom-textlist">
                      <div class="bottom-imglit">
                          <img src="../../../assets/images/手机端/222/警徽拷贝2@2x.png" alt="">
                      </div>
                      苍南县公安局
                  </div>
                  <div class="bottom-textlist">
                      <div class="bottom-imglit">
                          <img src="../../../assets/images/手机端/222/警徽拷贝2@2x.png" alt="">
                      </div>
                      无锡市公安局
                  </div>
              </div>
          </li>
          <li class="leftScroll">
              <h3>政企</h3>
              <div class="c"></div>
              <p>智慧教育一体化平台解决方案</p>
              <div class="nav-bottom">
                  <div class="bottom-textlist">
                      <div class="bottom-imglit">
                          <img src="../../../assets/images/手机端/222/图层617@2x.png" alt="">
                      </div>
                      温州市城市建设发展集团有限公司
                  </div>
                  <div class="bottom-textlist">
                      <div class="bottom-imglit">
                          <img src="../../../assets/images/手机端/222/图层617@2x.png" alt="">
                      </div>
                      温州市数据管理发展集团有限公司
                  </div>
                  <div class="bottom-textlist">
                      <div class="bottom-imglit">
                          <img src="../../../assets/images/手机端/222/图层617@2x.png" alt="">
                      </div>
                      温州市教育投资集团有限公司
                  </div>
                  <div class="bottom-textlist">
                      <div class="bottom-imglit">
                          <img src="../../../assets/images/手机端/222/图层617@2x.png" alt="">
                      </div>
                      温州市市政工程建设开发有限公司
                  </div>
                  <div class="bottom-textlist">
                      <div class="bottom-imglit">
                          <img src="../../../assets/images/手机端/222/图层618@2x.png" alt="">
                      </div>
                      温州日报报业集团有限公司
                  </div>
                  <div class="bottom-textlist">
                      <div class="bottom-imglit">
                      </div>
                      前坤环境建设集团有限公司
                  </div>
              </div>
          </li>
        </ul> -->

      </div>
    </div>

    <div class="footer">
      <ul>
        <li @click="goyuzan">
          <p>玉瓒云校园</p>
          <i class="el-icon-arrow-right"></i>
        </li>
        <li @click="subMenu = !subMenu">
          <p>一云看板<i :class="subMenu ? 'el-icon-caret-bottom' : 'el-icon-caret-right'"></i></p>
          <i class="el-icon-arrow-right"></i>
        </li>
        <li v-if="subMenu" style="padding-left: 0.52rem;" @click="$router.push({ path: 'visualizationpage' })">
          <p>产品详情</p>
          <i class="el-icon-arrow-right"></i>
        </li>
        <li v-if="subMenu" style="padding-left: 0.52rem;" @click="$router.push({ path: 'pricepage' })">
          <p>产品定价</p>
          <i class="el-icon-arrow-right"></i>
        </li>
        <li @click="subMenu2 = !subMenu2">
          <p>域贝系列产品<i :class="subMenu2 ? 'el-icon-caret-bottom' : 'el-icon-caret-right'"></i></p>
          <i class="el-icon-arrow-right"></i>
        </li>
        <li v-if="subMenu2" style="padding-left: 0.52rem;" @click="goproductservice">
          <p>域贝证书宝</p>
          <i class="el-icon-arrow-right"></i>
        </li>
        <li v-if="subMenu2" style="padding-left: 0.52rem;" @click="gointegratedpage">
          <p>域贝一体化</p>
          <i class="el-icon-arrow-right"></i>
        </li>
        <li v-if="subMenu2" style="padding-left: 0.52rem;" @click="godate">
          <p>域贝大数据</p>
          <i class="el-icon-arrow-right"></i>
        </li>
      </ul>
      <div class="logn">
        <img src="../../../assets/images/手机端/首页 手机端/logo.png" alt="">
      </div>
      <div class="dianhua">
        <p><img src="../../../assets/images/手机端/首页 手机端/电话(1).png" alt="">400-051-0806</p>
      </div>
      <div class="dizhi">
        <p><img src="../../../assets/images/手机端/首页 手机端/地址.png" alt="">浙江省温州市鹿城区车站大道11号高联大厦1608室</p>
      </div>
      <img @click="iswei" class="erweima" src="../../../assets/images/手机端/首页手机端/二维码.png" alt="">

      <div class="footer-bottom">
        <p>备案号：浙ICP备13031672-1</p>
      </div>
    </div>
    <div class="mask"></div>
    <div class="mask1"></div>
    <div class="erweima1">
      <img src="../../../assets/images/手机端/电子证书 手机端(1)/lQLPJxZcoFsdZpFnZ7Auu4i-tN-_HgKY00v_AK4A_103_103.png" alt="">
    </div>
    <div class="ismask" @click.self="qiemask" v-show="ismask">
      <div class="isnav" v-show="isnav">
        <ul>
          <li @click="navto(1)">首页</li>
          <li @click="navto(9)">玉瓒云校园</li>
          <li @click="subMenu = !subMenu">一云看板<i :class="subMenu ? 'el-icon-caret-bottom' : 'el-icon-caret-right'"></i></li>
          <li v-if="subMenu" class="subLi" @click="navto(7)">产品详情</li>
          <li v-if="subMenu" class="subLi" @click="navto(8)">产品定价</li>
          <li @click="subMenu2 = !subMenu2">域贝系列产品<i :class="subMenu2 ? 'el-icon-caret-bottom' : 'el-icon-caret-right'"></i></li>
          <li v-if="subMenu2" class="subLi" @click="navto(2)">域贝证书宝</li>
          <li v-if="subMenu2" class="subLi" @click="navto(3)">域贝大数据</li>
          <li v-if="subMenu2" class="subLi" @click="navto(4)">域贝一体化</li>
          <!-- <li @click="navto(2)">域贝证书宝</li>
          <li @click="navto(3)">域贝大数据</li>
          <li @click="navto(4)">域贝一体化</li> -->
          <li @click="navto(5)">解决方案</li>
          <li @click="navto(6)">关于掌网</li>
        </ul>
      </div>
    </div>
    <div v-show="isweixiang" class="iserweima" @click.stop.self.prevent="isis">
      <img src="../../../assets/images/手机端/电子证书 手机端(1)/lQLPJxZcoFsdZpFnZ7Auu4i-tN-_HgKY00v_AK4A_103_103.png" alt="">
    </div>
  </div>
</template>
<script>
import Swiper from "swiper/js/swiper.min.js";
// import Swiper from 'swiper/dist/js/swiper.js';
import "swiper/css/swiper.css";
export default {
  data() {
    return {
      isnav: false,
      ismask: false,
      iscolor1: false,
      iscolor2: false,
      iscolor3: false,
      iscolor4: false,
      iscolor5: false,
      isweixiang: false,
      name: '',
      phone: '',
      subMenu: false,
      subMenu2: false
    }
  },
  mounted() {
    this.swiperInit()
  },
  methods: {
    swiperInit() {
      new Swiper('.swiper-container', {
        loop: true,
        pagination: {
          el: '.swiper-pagination',
        },
        // navigation: {
        //   nextEl: ".swiper-button-next",
        //   prevEl: ".swiper-button-prev",
        // },
      })
    },
    goproductservice() {
      this.$router.push({ path: 'hoproductservicepage' })
    },
    godate() {
      this.$router.push({ path: 'hodate' })
    },
    goyuzan() {
      window.location.href='http://www.yuzanyun.com'
    },
    gointegratedpage() {
      this.$router.push({ path: 'integratedpage' })
    },
    addnav() {
      this.ismask = !this.ismask
      this.isnav = !this.isnav
    },
    qiemask() {
      this.ismask = false
      this.isnav = false
    },
    clicklistcolor1() {
      this.iscolor1 = true
      setTimeout(() => {
        this.iscolor1 = false
      }, 1000)
    },
    clicklistcolor2() {
      this.iscolor2 = true
      setTimeout(() => {
        this.iscolor2 = false
      }, 1000)
    },
    clicklistcolor3() {
      this.iscolor3 = true
      setTimeout(() => {
        this.iscolor3 = false
      }, 1000)
    },
    clicklistcolor4() {
      this.iscolor4 = true
      setTimeout(() => {
        this.iscolor4 = false
      }, 1000)
    },
    clicklistcolor5() {
      this.iscolor5 = true
      setTimeout(() => {
        this.iscolor5 = false
      }, 1000)
    },
    iswei() {
      this.isweixiang = true
    },
    isis() {
      this.isweixiang = false
    },
    navto(n) {
      if (n == 1) {
        this.ismask = false
        this.isnav = false
      } else if (n == 2) {
        this.$router.push({ path: 'hoproductservicepage' })
      } else if (n == 3) {
        this.$router.push({ path: 'hodate' })
      } else if (n == 4) {
        this.$router.push({ path: 'integratedpage' })
      } else if (n == 5) {
        this.$router.push({ path: 'cooperationpage' })
      } else if (n == 6) {
        this.$router.push({ path: 'aboutpage' })
      } else if (n == 7) {
        this.$router.push({ path: 'visualizationpage' })
      } else if (n == 8) {
        this.$router.push({ path: 'pricepage' })
      } else if (n == 9) {
        window.location.href='http://www.yuzanyun.com'
      }
    },
    addjiejue() {
      // this.$router.push('cooperationpage')
    }
  }
}
</script>
<style lang="less" scoped>
a {
  text-decoration: none;
}

li {
  list-style: none;
}

p {
  margin: 0;
}

.aaaaaaa {
  font-size: 1rem;
}

body {
  min-width: 320px;
  max-width: 750px;
  width: 15rem;
  margin: 0 auto;
  line-height: 1.5;
  font-family: PingFangSC-Regular, sans-serif;
  background: #F2F2F2;
}

.header {
  position: fixed;
  top: 0;
  left: 0;
  height: 2.4rem;
  padding-bottom: .4688rem;
  width: 100%;
  padding-top: .7031rem;
  background-color: #fff;
  z-index: 9999999999;
}

.header-l {
  float: left;
  margin-left: .75rem;
  /* background-image: url('../images/首页 手机端/logo.png'); */
}

.header-l img {
  height: .8rem;
  object-fit: cover;
}

.header-r {
  width: 1.75rem;
  height: 1.375rem;
  float: right;
}

.header-r img {
  width: .62rem;
  height: .5rem;
}

.top-img {
  position: relative;
  margin-top: 2.4rem;
  // width: 15rem;
  height: 7.16rem;
}

.top-img h3 {
  position: absolute;
  top: 0;
  left: 0;
  font-weight: 400;
  font-family: Arial, PingFangSC-Semibold, sans-serif;
  color: #fff;
  font-size: .72rem;
  margin-left: .56rem;
  line-height: 7.16rem;
}

.top-img img {
  width: 100%;
  height: 7.16rem;
}

.main-1 {
  // margin-bottom: 1.5625rem;
  // padding: 0 .56rem;
  position: relative;
  width: 100%;
  height: 10rem;
  margin: -1rem auto;
  padding: 0 0.48rem;

  .top_tag {
    width: 100%;
    height: 3rem;
    background: #fff;
    margin-top: .5rem;
    display: flex;
    align-items: center;
    box-shadow: 2px 5px 7px 2px rgba(0, 0, 0, .05);

    img {
      // height: 2.5rem;
      float: left;
      object-fit: cover;
      width: 2.6rem;
      padding: 0.4rem;
    }

    .toptext_box {
      float: right;
      width: 70%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      // background: #4d5b75;
    }
  }
}

.main-1 ul {
  margin: 0;
  padding-left: 0;
  display: flex;
  justify-content: center;

}

.main-1 ul li {
  width: 33.333333%;
  height: 2.1875rem;
}

.date {
  position: relative;
  font-family: PingFangSC-Regular, sans-serif;
  font-size: .72rem;
  margin: 0;
  color: #475872;
  font-weight: 600;
  margin-left: .1875rem;
}

.date span {
  position: absolute;
  left: 1.6rem;
  font-size: .48rem;
  color: #475872;
}

.text {
  /* display: block; */
  font-weight: normal;
  margin: 0;
  margin-top: .2rem;
  font-size: .52rem;
  line-height: .82rem;
  color: #475872;
  margin-left: .1875rem;
}

.yubeishu {
  /* margin-bottom: 1.5625rem; */
  margin-top: 2.7rem;
  text-align: center;
  width: 100%;
}

.yubeishu img {
  height: 6rem;
}

.yubeishu h3 {
  /* padding-top: 1.6rem; */
  // margin-top: 2rem;
  font-weight: 600;
  font-family: Arial, PingFangSC-Semibold, sans-serif;
  text-align: center;
  font-size: .72rem;
  color: #2c3e5c !important;
  margin-bottom: .8rem !important;
}

.centre {
  padding: 0 1rem;
}

.centre p {
  margin-top: .8rem;
  font-size: .52rem;
  font-family: PingFangSC-Regular, sans-serif;
  text-align: left;
  text-indent: 2em;
  color: #4d5b75 !important;
  // letter-spacing: 0.12rem;
  line-height: .85rem;
  text-align: justify;
}

.centre button {
  width: 4.6rem;
  height: 1.44rem;
  background: transparent;
  border: 1px solid #999;
  border-radius: 2px;
  color: #4d5b75;
  margin-bottom: 1.6rem;
  margin-top: .8rem;
  font-size: .52rem !important;

  &:hover {
    color: white;
    background: linear-gradient(to right, #2170de, #4f98fe);
    border: 0px solid #999;
  }
}

.yitihua {
  text-align: center;
  padding-top: 1.25rem;
  padding-left: .48rem;
  padding-right: .56rem;
  background-color: #f5fbfe;

  .top-title {
    padding: 0 .52rem;
    text-align: left;
  }
}

.yitihua h3 {
  font-weight: 600 !important;
  font-family: Arial, PingFangSC-Semibold, sans-serif;
  color: #2c3e5c;
  font-size: .72rem !important;
  margin-bottom: 0;
  margin-top: .36rem;
  margin-bottom: .8rem;
}

.yitihua p {
  font-size: .52rem;
  font-family: PingFangSC-Regular, sans-serif;
  color: #475872;
  // letter-spacing: 0.12rem;
  // text-align: justify;
  line-height: .88rem;
  text-align: center;
}

.yitihua ul {
  margin-top: .8rem;
  padding: 0px;
  margin-bottom: 0;

}

.yitihua ul li {
  /* padding: 0 1.04rem; */
  padding-right: 1.04rem;
  text-align-last: left;
  display: flex;
  margin-bottom: .3125rem;
  background-color: #fff;
  height: 3.5rem;
}

.yitihua ul li .yitihua_rtext {
  // margin-left: -0.2rem;
}

.yitihua ul li .yitihua_rtext h3 {
  font-size: .56rem !important;
  color: #2c3e5c;
  margin-top: .57rem;
  margin-bottom: .36rem;
  font-weight: 400 !important;
  font-family: PingFangSC-Medium, sans-serif;
  text-align: left;
}

.yitihua ul li .yitihua_rtext p {
  width: 10.5rem;
  text-align: left;
  font-size: .52rem;
  color: #4d5b75;
  margin-bottom: 0;
  line-height: .68rem;
  font-family: PingFangSC-Regular, sans-serif;
}

.yitihua_limg img {
  margin-top: .89rem;
  width: 1.86rem;
  height: 1.72rem;
  margin: .9rem .5rem;
}

.yitihua button {
  width: 4.6rem;
  height: 1.44rem;
  border: 1px solid #999;
  background: transparent;
  color: #4d5b75;
  border-radius: 2px;
  margin-bottom: 1.6rem;
  margin-top: .625rem;
  font-size: .52rem;

  &:hover {
    color: white;
    background: linear-gradient(to right, #2170de, #4f98fe);
    border: 0px solid #999;
  }
}

.main-2 {
  text-align: center;
  margin-bottom: .625rem;
  padding: 0 1rem;
}

.main-2 h3 {
  margin-top: 1.6rem;
  margin-bottom: .8rem;
  text-align: center;
  font-weight: 600;
  font-size: .72rem !important;
  font-family: Arial, PingFangSC-Semibold, sans-serif;
  color: #2c3e5c !important;
  font-size: .6933rem;
}

.main-2 img {
  width: 7.04rem;
  height: 5.98rem;
  margin-bottom: .625rem;
}

.main-2 p {
  font-size: .52rem;
  font-family: PingFangSC-Regular, sans-serif;
  text-indent: 2em;
  padding: .52rem;
  line-height: .82rem;
  color: #4d5b75 !important;
  text-align: justify;
}

.main-3 {
  padding: 0 .56rem;
}

.main-3 ul {
  display: flex;
  flex-wrap: wrap;
  padding: 0;
  margin: 0px;
}

.main-3 ul li {
  /* float: left; */
  width: 48%;
  height: 3.9844rem;
  background-color: pink;
  margin-bottom: .4rem;

  /* margin-left: .4688rem; */
}

.main-3-botton {
  // width: 15rem;
  height: 4rem;
  margin-bottom: .4rem;
  padding-left: .48rem;
  padding-right: .48rem;
  padding-top: .4rem;
}

.img-1 {
  background-image: url('../../../assets/images/手机端/123(3)/组13.png');
  background-repeat: no-repeat;
  background-size: cover;
}

.img-2 {
  background-image: url('../../../assets/images/手机端/123(3)/组30.png');
  background-repeat: no-repeat;
  background-size: cover;
}

.img-3 {
  background-image: url('../../../assets/images/手机端/123(3)/组31.png');
  background-repeat: no-repeat;
  background-size: cover;
}

.img-4 {
  background-image: url('../../../assets/images/手机端/123(3)/组32.png');
  background-repeat: no-repeat;
  background-size: cover;
}

.img-5 {
  background-image: url('../../../assets/images/手机端/123(3)/组33.png');
  background-repeat: no-repeat;
  background-size: cover;
}

.main-3-botton h3 {
  margin-top: 0px;
  font-weight: normal;
  font-size: .56rem;
  font-family: Arial, PingFangSC-Semibold, sans-serif;
  color: #fff;
  margin-bottom: .3rem;
}

.main-3-botton p {
  font-family: PingFangSC-Regular, sans-serif;
  color: #fff;
  font-size: .24rem;
}

.main-3-botton h4 {
  margin: 0;
  font-weight: normal;
  margin-top: .4rem;
  font-family: PingFangSC-Regular, sans-serif;
  color: #fff;
  line-height: .66rem;
  font-size: .52rem;
}

.main-4 {
  text-align: center;
  margin-top: .8rem;
  height: 22rem;

  // background: pink;
  /* overflow: hidden; */
  /* padding: 0 .5313rem; */
  .swiper-container {
    width: 100%;
    height: 16rem;
  }

  .swiper-slide {
    width: 100%;
    height: 14.64rem;
    // background: url('../../../assets/images/手机端/123(2)/政企.png') ;
    // background-size: 100%;
    /* Center slide text vertically */
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    // -webkit-justify-content: center;
    // justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;

    // -webkit-align-items: center;
    // align-items: center;
    .title_box {
      position: absolute;
      // width: 200px;
      // height: 100px;
      // background: #4e6d96;
      margin-top: 4.2rem;
      margin-left: .4rem;

      h3 {
        text-align: left;
        // margin-top: 4.6rem;
        margin-bottom: 0;
        font-weight: normal;
        font-size: .6rem;
        color: #fff !important;
        font-family: Arial, PingFangSC-Semibold, sans-serif;
      }

      .c {
        width: .52rem;
        height: .08rem;
        margin: .3rem 0;
        background-color: #f5fbfe;
      }

      p {
        font-size: .52rem;
        color: #fff;
        font-family: PingFangSC-Regular, sans-serif;
        /* margin-bottom: .32rem; */
      }
    }

  }

  .swiper-slide img {
    width: 100%;
    height: 100%;
  }

  .swiper-button-prev:after,
  .swiper-button-next:after {
    font-size: .6rem;
    color: #eee;
  }

  .swiper-pagination {
    position: absolute;
    bottom: 0px;
  }

  /deep/.swiper-pagination-bullet {
    width: 20px;
    height: 5px;
    display: inline-block;
    border-radius: 0%;
    background: #000;
    opacity: 0.2;
  }

  /deep/.swiper-pagination-bullet-active {
    opacity: 1;
    background: #007aff;
  }
}

.main-4 button {
  width: 4.6rem;
  height: 1.44rem;
  background: transparent;
  border: 1px solid #999;
  color: #4d5b75;
  border-radius: 2px;
  margin-bottom: 1.6rem;
  font-size: .52rem;

  &:hover {
    color: white;
    background: linear-gradient(to right, #2170de, #4f98fe);
    border: 0px solid #999;
  }
}

.main-4 h3 {
  margin-top: 0;
  text-align: center;
  font-weight: 600;
  font-family: Arial, PingFangSC-Semibold, sans-serif;
  color: #2c3e5c !important;
  font-size: .72rem;
  margin-bottom: 40px;
}

.main-4 .nav {
  padding: 0 .56rem;
  overflow-y: auto;
  /*可滑动*/

}

.main-4 .nav::-webkit-scrollbar {
  display: none;
}

.main-4 ul {
  text-align: left;
  width: 300%;
  height: 14.64rem;
  overflow: hidden;
  margin: 0;
  padding: 0px;
}

.main-4 ul li {
  position: relative;
  float: left;
  margin-right: .3125rem;
  padding-left: .4rem;
  width: 30%;
  height: 14.64rem;
  background-repeat: no-repeat;
  background-size: contain;
}

.main-4 ul li:nth-child(1) {
  background: url('../../../assets/images/手机端/123(2)/教育.png');
  background-size: 100%;

}

.main-4 ul li:nth-child(2) {
  background: url('../../../assets/images/手机端/123(2)/公安.png');
  background-size: 100%;
}

.main-4 ul li:nth-child(3) {
  background: url('../../../assets/images/手机端/123(2)/政企.png');
  background-size: 100%;
  margin-right: 0;
}

.main-4 ul li h3 {
  text-align: left;
  margin-top: 4.6rem;
  margin-bottom: 0;
  font-weight: normal;
  font-size: .55rem;
  color: #fff !important;
  font-family: Arial, PingFangSC-Semibold, sans-serif;
}

.nav-bottom {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 7.72rem;
  text-align: left;
  background-color: rgba(49, 134, 253, .7) !important;
}

.bottom-imglit {
  float: left;
  width: .68rem;
  height: .68rem;
  margin-right: .36rem;
  margin-left: .32rem;
}

.bottom-imglit img {
  width: .62rem;
  height: .58rem;
}

.nav-bottom .bottom-textlist {
  float: left;
  font-size: .52rem;
  width: 100%;
  color: #fff;
  display: flex;
  align-items: center;
  margin-top: .52rem;
}

.leftScroll .c {
  width: .52rem;
  height: .08rem;
  margin: .3rem 0;
  background-color: #f5fbfe;
}

.leftScroll p {
  font-size: .52rem;
  color: #fff;
  font-family: PingFangSC-Regular, sans-serif;
  /* margin-bottom: .32rem; */
}

.footer {
  position: relative;
  margin-top: .8rem !important;
  padding: 0 .56rem;
  background-color: #4d73ff;
}

.footer ul {
  margin: 0;
  padding: 0;
}

.footer ul li {
  height: 2rem;
  height: 2rem;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.footer ul li p {
  font-size: .52rem;
  color: #fff;
  font-family: PingFangSC-Regular, sans-serif;
}

.el-icon-arrow-right {
  font-size: .56rem;
  margin-right: -0.1rem;
  color: #fff;
}

.logn img {
  width: 5.625rem;
  height: 1.5625rem;
  margin-top: .625rem;
  margin-bottom: .625rem;
  /* width: ; */
  /* background-color: pink; */
}

.dianhua img {
  width: .3281rem;
  height: .3281rem;
  margin-right: .3125rem;
}

.dianhua p {
  font-size: .48rem;
  color: #fff;
  font-family: PingFangSC-Regular, sans-serif;
}

.dizhi {
  margin-top: .3125rem;
  margin-bottom: .625rem;
}

.dizhi img {
  width: .3281rem;
  height: .3281rem;
  margin-right: .3125rem;
}

.dizhi p {
  font-size: .48rem;
  color: #fff;
  font-family: PingFangSC-Regular, sans-serif;
}

.footer-bottom {
  border-top: 1px solid #eee;
  height: 1.4063rem;
}

.footer-bottom {
  padding-top: .3125rem;
  font-size: .48rem;
  color: #fff;
  font-family: PingFangSC-Regular, sans-serif;
}

.addbtn {
  width: 3.04rem;
  height: 1.2rem;
  background-color: #5d7bff !important;
  /* 不支持线性的时候显示 */
  background-image: linear-gradient(to right, #5d7bff, #7b9cff);
  border: 0px;
  border-radius: 2px;
  margin-bottom: 1.25rem;
  font-size: .56rem;
  color: #fff;
  border: none !important;
}

.aaa {
  display: block !important;
  position: fixed;
  top: 0;
  right: 0;
  width: 45%;
  height: 100%;
  background-color: #fff;
  z-index: 9999999999999;
}

.mask {
  display: none;
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgb(0, 0, 0);
  opacity: .2;
}

.maskis {
  display: block;
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgb(0, 0, 0);
  opacity: .2;
}

.listiscolor1 {
  box-shadow: 1px 1px 4px 1px rgba(95, 92, 92, 0.22);
}

.listiscolor2 {
  box-shadow: 1px 1px 4px 1px rgba(95, 92, 92, 0.22);
}

.listiscolor3 {
  box-shadow: 1px 1px 4px 1px rgba(95, 92, 92, 0.22);
}

.listiscolor4 {
  box-shadow: 1px 1px 4px 1px rgba(95, 92, 92, 0.22);
}

.listiscolor5 {
  box-shadow: 1px 1px 4px 1px rgba(95, 92, 92, 0.22);
}

.erweima {
  width: 1.74rem;
  height: 1.74rem;
  position: absolute;
  right: .56rem;
  bottom: 2rem;
}

.erweima1 {
  display: none;
  position: fixed;
  bottom: 50%;
  left: 50%;
  transform: translate(-3.6rem, 3.6rem);
}

.erweima1 img {
  width: 7.2rem;
  height: 7.2rem;
}

.ismask {
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  width: 100%;
  height: 10000px !important;
  background: rgba(0, 0, 0, .2) !important;
}

.isnav {
  position: fixed;
  top: 2.4rem;
  right: 0;
  width: 0rem;
  height: 100%;
  background-color: #fff;
  animation: isnav .5s forwards;

  ul {
    padding: 0 .68rem;

    li {
      height: 2.12rem;
      line-height: 2.12rem;
      color: #2c3e5c;
      font-size: .56rem;
      font-family: Arial, PingFangSC-Semibold, sans-serif;
      border-bottom: 1px solid #eee;
    }

    .subLi {
      padding-left: .58rem;
    }

    li:nth-child(1) {
      border-top: 1px solid #eee;
    }
  }
}

@keyframes isnav {
  0% {
    width: 0rem;
  }

  100% {
    width: 9rem;
  }
}

.iserweima {
  position: fixed;
  z-index: 99999;
  top: 0;
  left: 0;
  width: 100%;
  height: 10000px !important;
  background: rgba(0, 0, 0, .2) !important;

  img {
    position: fixed;
    // width: 3.6rem;
    // height: 3.6rem;
    top: calc(50% - 90px);
    left: calc(50% - 90px);
    // left: 50%;
    // top: 50%;
    // transform: translate(-50%,-50%);

  }
}
</style>
